/**
 * Created by alex.y on 7/31/2017.
 */
import {ChangeDetectorRef, Component, EventEmitter, Output} from "@angular/core";
import {Location} from "../../../../objects/management/locationManagement/location";

@Component({
    selector: "location-management-search",
    templateUrl: "./locationManagementSearch.component.html",
    moduleId: module.id.toString()
})
export class LocationManagementSearchComponent{
    @Output()
    public searchEvent: EventEmitter<Location> = new EventEmitter();

    public searchQueryString: string;

    public searchQuery: Location = new Location();

    public searchInput: string;

    public constructor(private ChangeDetectorRef : ChangeDetectorRef){}

    public submit(): void {
        if (!this.searchQueryString)
            this.searchQuery = new Location();

        this.searchEvent.emit(this.searchQuery);
    }

    public onLocationChange(location: Location): void{
        this.searchQuery = location;
        this.ChangeDetectorRef.detectChanges();
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/locationManagement/locationManagementSearch/locationManagementSearch.component.ts